<template>
	<section
		v-if="data && ((loadingPostsStatus === 'success' && postItems.length) || loadingPostsStatus === 'loading')"
		class="module-posts margin-bottom-lg margin-top-lg"
	>
		<div class="container margin-auto margin-both-lg">
			<div class="heading-mod margin-bottom-sm">
				<h2 v-if="moduleTitle" class="module-title">{{ moduleTitle }}</h2>
			</div>
			<PostsGrid v-if="loadingPostsStatus === 'success' && postItems && postItems.length" :posts="postItems" />
			<div class="bottom-button margin-top-sm">
				<Button :type="buttonColor" arrow-link uppercase link :outlined="false">
					<router-link v-if="archiveLinkShow" :to="archiveInfo.link">
						<span class="txt">{{ archiveInfo.text }}</span>
					</router-link>
				</Button>
			</div>
		</div>
	</section>
</template>

<script>
import DummyLine from '@/components/elements/DummyLine'
import PostsGrid from '@/components/parts/PostsGrid'
import Button from '@/components/elements/Button'
import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'
// I WISH TO HAVE TIME TO REBUILD WHOLE CRAP!!!!! AAAGGAAA
export default {
	name: 'posts-module',
	props: ['data'],
	data() {
		return {
			archiveLinkShow: true,
			postType:
				this.data && (this.data.type || this.data.show_type) ? this.data.type || this.data.show_type : 'post',
			postItems: [],
			loadingPostsStatus: 'loading',
		}
	},
	components: {
		DummyLine,
		PostsGrid,
		Button,
	},
	mounted() {
		const VM = this
		if (!VM.data) return false

		if (VM.includePosts) {
			VM.loadPosts({
				type: VM.postType || 'post',
				include: VM.includePosts,
				exclude: VM.exclude,
				limit: VM.data.limit || 2,
			}).then((e) => {
				//load rest of posts
				if (e === 'success' && VM.postItems.length < 2) {
					VM.loadPosts({
						type: VM.postType || 'post',
						exclude: [...VM.exclude, ...VM.includePosts],
						limit: 2 - VM.postItems.length,
						category: VM.data.select_category || 0,
						//tags : VM.data.select_category || 0,
						//taxonomy : VM.taxonomy,
					})
				}
			})
		} else {
			VM.loadPosts()
		}
	},
	computed: {
		...mapGetters(['currentPageID', 'getOptions']),
		moduleTitle() {
			return this.data.title || this.data.module_title
		},
		taxonomy() {
			let taxonomy = ''
			switch (this.postType) {
				case 'post':
					taxonomy = 'category'
					break
			}

			return taxonomy
		},
		includePosts() {
			return this.data.news_to_display || 0
		},
		archiveInfo() {
			let text = 'Alle artikler'
			let link =
				this.getOptions && this.getOptions.articles_archive
					? '/' + this.getOptions.articles_archive.slug
					: '/articles'
			return { link, text }
		},
		buttonColor() {
			let color = 'white'
			return color
		},
		loadOpt() {
			const VM = this
			if (!VM.data) return []
			const opt = {
				action: 'cached',
				type: VM.postType || 'post',
				include: VM.includePosts,
				exclude: VM.data.exclude || 0,
				service: VM.data.service || null,
				market: VM.data.market || null,
				limit: VM.data.limit || 2,
				category: VM.data.select_category || 0,
				//tags : VM.data.select_category || 0,
				//taxonomy : VM.taxonomy,
			}
			return opt
		},
		exclude() {
			let exclude = 0
			if (this.currentPageID) {
				exclude = [this.currentPageID]
			}
			if (this.data.exclude) {
				exclude = [...exclude, ...this.data.exclude]
			}
			return exclude
		},
	},

	methods: {
		...mapActions(['getPost']),
		loadPosts(options) {
			if (!options) {
				options = this.loadOpt
			}
			//console.log(options)
			const VM = this
			VM.loadingPostsStatus = 'loading'
			return VM.getPost(options).then((res) => {
				if (res.data && res.data.posts && res.data.posts.length) {
					if (VM.includePosts) {
						VM.postItems.push(...mapOrder(res.data.posts, VM.includePosts, 'id'))
					} else {
						VM.postItems.push(...res.data.posts)
					}
				}
				VM.loadingPostsStatus = 'success'
				return VM.loadingPostsStatus
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-posts {
}
</style>
